export default __webpack_public_path__ + "static/media/icon-mi-carrera.46fbe1c9.svg";